import React, { Component } from 'react';
// import { BrowserRouter, Link } from 'react-router-dom';
import axios from 'axios';

// components
// import Search from '../singlets/Search';

export class Sticky extends Component  {
  state = {
    mainnav: [], stickynav: []
  }

  componentDidMount() {
    window.addEventListener('scroll', this.stickyHeader);

    const getMainNav = axios.get('https://www.usa.edu/wp-json/wp-api-menus/v2/menus/4');
    // const getStickyNav = axios.get('https://www.usa.edu/wp-json/wp-api-menus/v2/menus/648');

    // Promise.all([getMainNav, getStickyNav]).then(res => {
    Promise.all([getMainNav]).then(res => {
      // console.dir(res);
      this.setState({
        mainnav: res[0].data.items,
        // stickynav: res[1].data.items,
      });
    });
  }

  stickyHeader() {
    let header = document.querySelector('header');
    (window.pageYOffset > header.clientHeight)? header.classList.add('open') : header.classList.remove('open');
  }

  render() {
    const { mainnav } = this.state;
    // console.dir(mainnav);
    // console.dir(stickynav);

    return (
      <>
        <section id="sticky">
          <div className="container">
            <div className="row">
              <div className="col-1 branding">
                <a href="https://www.usa.edu/"> <img src={process.env.PUBLIC_URL + '/global/images/logos/crest192.png'} alt="University of St. Augustine for Health Sciences" /> </a>
              </div>

              <nav className="col-11">
                <ul>
                  {mainnav.map(nav =>
                    <li key={ nav.id } className={ nav.classes }> <a href={ nav.url } dangerouslySetInnerHTML={{ __html: nav.title }} /> </li>
                  )}

                  {/* {stickynav.map(nav =>
                    <li key={ nav.id } className={ nav.classes }> <a href={ nav.url } dangerouslySetInnerHTML={{ __html: nav.title }} /> </li>
                  )} */}

                  <li className="highlight"> <a href="https://www.usa.edu/request-information/">Request Information</a> </li>
                  <li className=""> <a href="https://www.usa.edu/apply/">Apply Now</a> </li>
                </ul>

                {/* <Search /> */}
              </nav>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default Sticky;